
import FileSaver from 'file-saver';

export default {
    name: 'Share',
    props: {
        url: String,
        post: Object,
        profile: Object,
        title: String,
        subtitle: String,
        analytics: Object,
        shareVideoUrl: String,
        shareAudioUrl: String,
    },
    data() {
        return {
            showCopySuccess: false,
            cssSocialIcon: 'inline-flex flex-col items-center text-center transition group',
            cssSocialIconSvg: 'w-12 h-12 transition group-hover:scale-105',
            cssSocialIconText: 'mt-2 leading-tight text-xs text-black/60 transition group-hover:text-black/90',
        };
    },
    computed: {
        encodedURL() {
            return encodeURIComponent(this.url);
        },
    },
    methods: {
        copy() {
            let copyText = document.querySelector('#share-url');
            copyText.select();
            copyText.setSelectionRange(0, 99999); /*For mobile devices*/
            document.execCommand('copy');
            this.showCopySuccess = true;
            this.didShare('copy');
        },

        showModal(component) {
            this.$store.commit('ui/hideModal');

            this.$store.commit('ui/showModal', {
                component: component,
                props: {
                    post: this.post,
                    profile: this.profile,
                    url: this.url,
                    shareVideoUrl: this.shareVideoUrl,
                },
            });
            this.didShare(component.toLowerCase());
        },

        didShare(shareType) {
            this.$analytics.trackEvent('share', {
                ...this.analytics,
                share_type: shareType,
            });
        },

        saveFile(url, fileName) {
            FileSaver.saveAs(url, fileName);
        },
    },
};
